import { render, staticRenderFns } from "./salesOrderScanOut_v2.vue?vue&type=template&id=bf343134&scoped=true&"
import script from "./salesOrderScanOut_v2.vue?vue&type=script&lang=js&"
export * from "./salesOrderScanOut_v2.vue?vue&type=script&lang=js&"
import style0 from "./salesOrderScanOut_v2.vue?vue&type=style&index=0&id=bf343134&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf343134",
  null
  
)

component.options.__file = "salesOrderScanOut_v2.vue"
export default component.exports